import { Button } from "devextreme-react";
import "./copilot-display.scss";
import { useState } from 'react';
import LoadIndicator from 'devextreme-react/load-indicator'
import { useLogisticsService } from 'services'

const CopilotDisplay = ({ loadNumber }) => {

  const { sendPreferredRouteToTrimbleTripManagement } = useLogisticsService();

  const [isSendingToTrimble, setIsSendingToTrimble] = useState(false);

  const sendToTrimble = async () => {
    setIsSendingToTrimble(true);

    await sendPreferredRouteToTrimbleTripManagement(loadNumber)
      .then(() => {
        setIsSendingToTrimble(false);
      })
  };
  
  return (
    <div className="submit-trimble-btn-wrapper">
      {isSendingToTrimble == false &&
        <Button
          className="submit-trimble-btn"
          onClick={() => sendToTrimble()}
        >
          SEND TO COPILOT
        </Button>
      }

      {isSendingToTrimble &&
        <div className="load-indicator-container">
          <LoadIndicator height={200} width={200} />
      </div>
      }
    </div>
  );
};

export default CopilotDisplay;
